<script setup lang="ts">
import type { Link } from '@/models'
import LocalisedLink from '@/components/LocalisedLink.vue'
import LinkIcon from '@/assets/link-icon.svg'

defineProps<{
  links?: Link[]
  justify?: 'start' | 'center' | 'end'
  customClass?: string
}>()
</script>

<template>
  <div
    v-if="links?.length"
    class="flex flex-row w-full pt-12 block-links"
    :class="[
      justify === 'start' ? 'justify-start' : '',
      justify === 'center' ? 'justify-center' : '',
      justify === 'end' ? 'justify-end' : '',
      customClass,
    ]"
  >
    <template v-for="link of links" :key="link.url">
      <div v-if="link.url.includes('http')" class="flex flex-row">
        <a :href="link.url"
          ><span class="font-bold underline">{{ link.title }}</span></a
        >
        <img class="ml-2 w-6 filter invert" :src="LinkIcon" alt="Footer Image" />
      </div>
      <LocalisedLink v-else :to="link.url" class="mr-2 flex">
        <div class="cursor-pointer px-2 py-1 bg-purple text-white font-alexandria shadow-md/50">
          <p class="lowercase font-light [font-variant:small-caps] whitespace-nowrap">
            {{ link.title }}
          </p>
        </div>
      </LocalisedLink>
    </template>
  </div>
</template>
